import { BASE_URL } from '../config/config'
import { builder } from '../utils/queryBuilder'
import Fetch from './Fetch'

export const getAllFactoryOrders = async body => {
    const params = builder({
        code: body.code,
        number_of_left: body.number_of_left,
        take: body.take,
        skip: body.skip,
        name: body.name,
    })
    return await Fetch.get(`${BASE_URL}product/admin/factory${params}`)
}
export const getPrintableFactoryOrders = async body => {
    const params = builder({
        code: body.code,
        number_of_left: body.number_of_left,
        name: body.name,
    })
    return await Fetch.get(`${BASE_URL}product/admin/factory${params}`)
}

export const getAllProduct = async body => {
    const params = builder({
        name: body.name,
        take: body.take,
        skip: body.skip,
        is_vip: body.is_vip,
    })
    return await Fetch.get(`${BASE_URL}product/admin${params}`)
}

export const getAllProductsToPrint = async body => {
    const params = builder({ name: body.name, is_vip: body?.is_vip })
    return await Fetch.get(`${BASE_URL}product/admin${params}`)
}

export const getAllUserProducts = async body => {
    const params = builder({
        name: body.name,
        take: body.take,
        skip: body.skip,
    })
    return await Fetch.get(`${BASE_URL}product${params}`)
}

export const createNewProductByAdmin = async body =>
    await Fetch.post(`${BASE_URL}product/admin`, body)

export const updateProductByAdmin = (id, body) =>
    Fetch.patch(`${BASE_URL}product/admin/${id}`, JSON.stringify(body), {
        headers: {
            'Content-Type': 'application/json',
        },
    })

export const deleteProductByAdmin = id =>
    Fetch.delete(`${BASE_URL}product/admin/${id}`)
